import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_FABRIC_TRADING_RESOURCE,
  GET_FABRIC_TRADING_LIST_RESOURCE,
} from "./actionTypes"
import {
  getFabricTradingAPI,
  getFabricTradingListAPI,
} from "helpers/fabric_trading_company_resource"

import {
  getFabricTradingResourceSuccess,
  getFabricTradingResourceError,
  getFabricTradingListResourceSuccess,
  getFabricTradingListResourceError,
} from "./actions"
import debounce from "debounce-promise"

const debouncegetFabricTradingAPI = debounce(getFabricTradingAPI, 1000)
const debouncegetFabricTradingListAPI = debounce(getFabricTradingListAPI, 1000)

// get global state
export const getState = ({ Users }) => Users

function* fetchFabricTrading(args) {
  let params = args.payload
  yield put(getFabricTradingResourceSuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetFabricTradingAPI, params)
    yield put(getFabricTradingResourceSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getFabricTradingResourceError(error?.response))
  }
}

function* fetchFabricListTrading() {
  yield put(
    getFabricTradingListResourceSuccess({ status: "process", data: [] })
  )
  try {
    let { data } = yield call(debouncegetFabricTradingListAPI)
    yield put(getFabricTradingListResourceSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getFabricTradingListResourceError(error?.response))
  }
}

function* fabricTradingSaga() {
  yield takeEvery(GET_FABRIC_TRADING_RESOURCE, fetchFabricTrading)
  yield takeEvery(GET_FABRIC_TRADING_LIST_RESOURCE, fetchFabricListTrading)
}

export default fabricTradingSaga
